/**
 * Convert time to proper MM:SS format:
 *  12 -> '00:12'
 *  74 -> '1:14'
 *  ':12' -> '0:12'
 *  '1:12' -> '1:12'
 *  '1:74' -> '2:14'
 *  'ab:' -> ''
 * @param {Number|String} input
 * @returns {*}
 */
export const getMinutesSecondsTime = (input: string | number) => {
  let matchedSeconds
  let matchedMinutes

  if (Number(input)) {
    matchedMinutes = 0
    matchedSeconds = Number(input)
  } else {
    const inputString = String(input)
    const format = /^(\d*):?(\d+)$/
    const match = inputString.match(format)

    if (!match) {
      return ''
    }

    matchedMinutes = match[1] ? Number(match[1]) : 0
    matchedSeconds = match[2] ? Number(match[2]) : 0
  }

  const additionalMinutes = Math.floor(matchedSeconds / 60)
  const seconds = matchedSeconds - additionalMinutes * 60
  const minutes = matchedMinutes + additionalMinutes
  const secondsFormatted =
    seconds < 9.5 ? '0' + seconds.toFixed(0) : String(seconds.toFixed(0))
  const minutesFormatted = String(minutes)
  return `${minutesFormatted}:${secondsFormatted}`
}

/**
 * Convert user input MM:SS to seconds
 * 12 -> 12
 * '0:12' -> 12
 * '1:12' -> 72
 * 'ab' -> ''
 * @param  {String|Number} input
 * @return {Number} time in seconds
 */
export const toSeconds = (input: string | number) => {
  const timeReg = /^([0-9]?[0-9]):([0-5][0-9])(:[0-5][0-9])?$/
  const inputStr = input.toString()
  if (Number(input)) {
    if (parseInt(inputStr, 10) < 0) {
      return 0
    } else {
      return parseInt(inputStr, 10)
    }
  } else if (timeReg.test(inputStr)) {
    const parts = inputStr.split(':')
    let sec = 0
    let min = 1

    while (parts.length > 0) {
      const part = parts.pop()

      if (part) {
        sec += min * parseInt(part, 10)
        min *= 60
      }
    }

    return sec
  } else {
    return null
  }
}
